import React, { useState } from "react";

const ProductDescriptionContainer = (props) => {
  var containerObject = props.containerObject
  const [colorViewStatus, setColorViewStatus] = useState("")

  const handleProductColorViewCallback = (viewColor) => {
    setColorViewStatus(viewColor)
  }
  return (
    <>
    {containerObject.pdpData.pdp ?
            <div className='card-text' dangerouslySetInnerHTML={{ __html: containerObject.pdpData.pdp }}></div>
            : ""} 
    </>
    // <div data-cont-id={containerObject.contentId} data-zone={props.dataZone} data-page-id={props.contentId} data-template-name={props.templateName} >
    //   <div className="container-fluid mt-5">
    //     <div className='row mt-4 mx-2'>
    //       <ProductDescriptionImage ProductJsonData={containerObject} colorViewStatus={colorViewStatus} />
    //       <ProductDescriptionView ProductJsonData={containerObject} handleProductColorViewCallback={handleProductColorViewCallback} />
    //     </div>
    //     <div className="row descriptionMargins backgroundDescription productDetailsMargins">
    //       <ProductDescriptionSubReviewPage ProductJsonData={containerObject} />
    //     </div>
    //     {console.log("pdp",containerObject)}
    //   </div>
    // </div>
  )
}

export default ProductDescriptionContainer